
<file-browser patient="patrCtrl.patient"></file-browser>
<document-list patient="patrCtrl.patient"></document>